import { lazyNamed } from 'src/utils/lazyNamed.ts';

export const AnalyticsTool = {
  Helmet: lazyNamed(() => import('./Helmet.tsx'), 'Helmet'),
  PageImpressions: lazyNamed(() => import('./pages/PageImpressions/index.tsx'), 'PageImpressions'),
  AdImpressions: lazyNamed(() => import('./pages/AdImpressions/index.tsx'), 'AdImpressions'),
  FillRateAttribution: lazyNamed(() => import('./pages/FillRateAttribution/index.tsx'), 'FillRateAttribution'),
};
